import { ManageAlarmTypesInGroupRequestDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useManageAlarmTypesInGroup(
  alarmTypeGroupId: number,
  onSuccess: () => void
) {
  const url = `/v2/orm/alarmtype_groups/${alarmTypeGroupId}/alarmtype`;

  const request = new Request(url, {
    method: 'PATCH',
  });

  return useAuthenticatedMutation<null, ManageAlarmTypesInGroupRequestDTO>(
    request,
    {
      onSuccessInvalidationKeys: [['alarm-type-groups']],
      onSuccess,
    }
  );
}

export default useManageAlarmTypesInGroup;
